import { createTheme } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Theme {
    brand: {
      primary: string;
      secondary: string;
    };
    background: {
      default: string;
      blue: string;
      red: string;
      green: string;
      light1: string;
      light2: string;
      light3: string;
    };
    greyscale: {
      white: string;
      lightgrey1: string;
      lightgrey2: string;
      grey1: string;
      grey2: string;
      grey3: string;
      grey4: string;
      darkgrey1: string;
      darkgrey2: string;
      darkgrey3: string;
    };
  }

  interface ThemeOptions {
    brand?: {
      primary?: string;
      secondary?: string;
    };
    background?: {
      default?: string;
      blue?: string;
      red?: string;
      green?: string;
      light1?: string;
      light2?: string;
      light3?: string;
    };
    greyscale?: {
      white?: string;
      lightgrey1?: string;
      lightgrey2?: string;
      grey1?: string;
      grey2?: string;
      grey3?: string;
      grey4?: string;
      darkgrey1?: string;
      darkgrey2?: string;
      darkgrey3?: string;
    };
  }

  interface TypographyVariants {
    display: React.CSSProperties;
    body3: React.CSSProperties;
    body4: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    display?: React.CSSProperties;
    body3?: React.CSSProperties;
    body4?: React.CSSProperties;
  }
}

const theme = createTheme({
  typography: {
    fontFamily: "Pretendard, sans-serif",
    h1: {
      fontSize: "36px",
      fontWeight: 700,
      lineHeight: "46px",
      letterSpacing: "-0.02em",
    },
    h2: {
      fontSize: "32px",
      fontWeight: 700,
      lineHeight: "42px",
      letterSpacing: "-0.02em",
    },
    h3: {
      fontSize: "28px",
      fontWeight: 700,
      lineHeight: "34px",
      letterSpacing: "-0.02em",
    },
    h4: {
      fontSize: "24px",
      fontWeight: 500,
      lineHeight: "34px",
      letterSpacing: "-0.02em",
    },
    h5: {
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: "30px",
      letterSpacing: "-0.02em",
    },
    h6: {
      fontSize: "18px",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: "-0.02em",
    },
    subtitle1: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: "-0.02em",
    },
    subtitle2: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "22px",
      letterSpacing: "-0.02em",
    },
    body1: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: "-0.02em",
    },
    body2: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "22px",
      letterSpacing: "-0.02em",
    },
    body3: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "18px",
      letterSpacing: "-0.02em",
    },
    body4: {
      fontSize: "12px",
      fontWeight: 600,
      lineHeight: "18px",
      letterSpacing: "-0.02em",
    },
  },

  background: {
    default: "#ffffff",
    blue: "#357aff",
    red: "#ff6584",
    green: "#18e661",
    light1: "#f5f5f5",
    light2: "#e8e8e8",
    light3: "#eafffd",
  },
});

export default theme;
